export const GET_LOCATIONS = "GET_LOCATIONS";
export const GET_LOCATION = "GET_LOCATION";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const UPDATE_LOCATIONS = "UPDATE_LOCATIONS";
